import { App } from 'vue';

export default ({ app }: { app: App<any> }) => {
  app.directive('bridge', {
    beforeMount: function () {

    },
    updated: function () {

    },
    unmounted: function () {

    },
  });
  app.directive('local-hidden', {})

  app.directive('tracker', {})
  app.directive('digit-flip', {})
}
